import { useState } from "react";
import { useMainContext } from "../../../Context";
import { dashboard } from "../../../Utils/Apis";
import { useEffect } from "react";

export const useDashboard = () => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const {
    get,
    state: {
      user: { user },
    },
    post,
  } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data } = await get(dashboard);
    setState(data);
    setLoading(false);
  };
  const send = async () => {
    setLoadingBtn(true);
    const { data } = await post("/user/subscription/renewal");
    if (data.url) {
      window.location.replace(data.url);
    }
    // setState(data);
    setLoadingBtn(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return { state, loading, user, send, loadingBtn };
};
